<template>
    <div>
        <input class=" w-full h-11 rounded-3xl px-6 bg-white text-20"
                v-model="content"
                :maxlength="inputMaxLength"
                @input="onChange()">
    </div>
</template>

<script>
/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Boolean} isTextOnly (optional) Only text.
 * @property {Object} inputLbl (required) Text for component.
 */
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";
export default {
    name: 'InputSearch',
    props: {
        // v-model
        inputValue:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        isTextOnly:     { type: Boolean, default: false },
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: null,
            SearchCampaignList:[],
            listConfig: null,
            filterConfig: null,
        };
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.invalid);
            }
        },
        onChange: function() {
            let result = this.content;

            if (this.isTextOnly) {
                result = RegxHelper.removeEmoji(result);
                result = RegxHelper.removeNumber(result);
                result = RegxHelper.removeSymbol(result);
            }

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
    },
}
</script>

